import { Component, Output, EventEmitter } from "@angular/core";
import { ModalService } from "@services/modal.service";
import { CashNowService } from "@services/cash-now.service";

@Component({
  selector: "app-modal-exit-current-page",
  templateUrl: "./modal-exit-current-page.component.html",
  styleUrls: ["./modal-exit-current-page.component.scss"],
})
export class ModalExitCurrentPageComponent {

  @Output() exitPage: EventEmitter<boolean> = new EventEmitter();

  constructor(private cashNow: CashNowService, public modal: ModalService) {}

  exitFromThePage(value: boolean) {
    this.cashNow.deleteCheckedBills().subscribe(
      (res) => {
        console.log(res.message);
      },
      (error) => {
        console.log(error);
      }
    );
    return this.exitPage.emit(value);
  }

  ngOnDestroy() {
    this.modal.close();
  }
}
